import { Record } from 'immutable';

export default class StaffingCompanyRecord extends Record({
  id: undefined,
  address: undefined,
  customerOrderConfirmationEmailText: undefined,
  employerCertificateKey: undefined,
  emailFooter: undefined,
  unemploymentAgencyId: undefined,
  employerCertificateUsername: undefined,
  employmentPaymentTerms: undefined,
  invoiceFooterColumn2: undefined,
  invoiceFooterColumn3: undefined,
  invoicePaymentTerms: undefined,
  name: undefined,
  oneflowBlueCollarCollectionId: undefined,
  oneflowBlueCollarTemplateId: undefined,
  oneflowWhiteCollarCollectionId: undefined,
  oneflowWhiteCollarTemplateId: undefined,
  organisationNumber: undefined,
  paymentOcrPrefix: undefined,
  resourceMileageAllowance: undefined,
  selfEmploymentPaymentTerms: undefined,
  standardTaxRate: undefined,
  standardVatRate: undefined,
}) {
}
